module.exports = __webpack_public_path__ + "logo-origami-black.png?9c33eace3de5a6c438d0d818728d754f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-origami-black.png
// module id = 44
// module chunks = 0